import { floating } from "javascripts/webpage/floating";
import { unmaskSlash } from "javascripts/webpage/link";

document.addEventListener("DOMContentLoaded", () => {
  floating();

  // 検索ボックスのクリックカウント
  const searchBoxes = document.querySelectorAll(".js-search-box");
  searchBoxes.forEach((searchBox) => {
    searchBox.addEventListener("submit", (event) => {
      event.preventDefault();
      // eslint-disable-next-line no-undef
      onclickcatalyst_clickcount("search_box", "event7");
      searchBox.setAttribute("action", unmaskSlash(searchBox.getAttribute("action")));
      searchBox.submit();
    });
  });

  // クリックカウント機能
  document.addEventListener("click", (event) => {
    if (event.target.classList.contains("js-click-count")) {
      const clickArea = event.target.getAttribute("data-click-area");
      const eventType = event.target.getAttribute("data-event");
      // eslint-disable-next-line no-undef
      onclickcatalyst_clickcount(clickArea, eventType);
    }
  });

  // 追従メニューを途中から表示
  const stickyElements = document.getElementsByClassName("js-sticky");
  if (stickyElements.length > 0) {
    const sticky = stickyElements[0];
    const target = document.getElementsByClassName("js-sticky-target")[0];

    if (target) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          sticky.classList.toggle("c-sticky--active", !entry.isIntersecting);
        });
      });
      observer.observe(target);
    }
  }
});
